var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file && _vm.file.media)?_c('vueVimeoPlayer',{ref:"player",attrs:{"video-id":_vm.vimeoId,"options":{ responsive: true }},on:{"error":_vm.error,"play":_vm.play,"ended":_vm.ended,"timeupdate":_vm.timeInterval,"ready":_vm.ready}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }